import * as types from './mutation-types';
import * as actions from './actions';

/**
 * TODO:
 *  Need to remove these below and build the components correctly but
 *  we need to get this working as fast as possible and rebuilding the
 *  components correctly is just not possible at this time
 */

const state = {
    emptyPositionsToTransplant: [],
    transplantContainerType: 0
};

const getters = {
    emptyPositionsToTransplant: state => state.emptyPositionsToTransplant,
    transplantContainerType: state => state.transplantContainerType,
}

const mutations = {
    setEmptyPositionsToTransplant(state, val = []) {
        state.emptyPositionsToTransplant = val || []; // This is required because javascript is a terrible language...
    },
    setTransplantContainerType(state, val) {
        state.transplantContainerType = val || 0;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
